import { render } from "./PromptDialog.vue?vue&type=template&id=6cd2da68&ts=true"
import script from "./PromptDialog.vue?vue&type=script&lang=ts"
export * from "./PromptDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__